import {connect} from 'react-redux';
import Translation from '../../../components/elements/translation/Translation';
import {openDialogEditTranslation, deleteTranslation} from "../../../actions/translationAction";

const mapStateToProps = (state, ownProps) => {
    return {
        translation: ownProps.translation
    }
};

const mapDispatchToProps = dispatch => {
    return {
        openDialogEditTranslation: (id, key, de, en, translationType) => {
            dispatch(openDialogEditTranslation(id, key, de, en, translationType))
        },
        deleteTranslation: (id) => {
            dispatch(deleteTranslation(id))
        }
    }
};

const TranslationContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Translation);

export default TranslationContainer;